// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Bc4x","footer":"ModalFilter_footer__3aJ9f"};